// extracted by mini-css-extract-plugin
export default {"panel":"Github_panel__QGQNC","calendar":"Github_calendar__R8kcf"};